<label class="case-search" aria-label="Search cases">
  <mat-icon aria-hidden="true">search</mat-icon>
  <input
    type="text"
    placeholder="Search"
    autocomplete="off"
    [value]="searchQuery"
    (input)="searchQueryChange.emit($any($event.target).value)"
  />
</label>

<div class="case-list">
  @for (item of cases; track item.id) {
    <button type="button" class="case-item" [class.selected]="item.selected" (click)="caseSelected.emit(item.id)">
      <span class="case-avatar"
        [style.background]="avatarColor(item.name)"
        [style.color]="'#fff'">{{ item.initials }}</span>

      <span class="case-copy">
        <span class="case-name">{{ item.name }}</span>
        <span class="case-code">{{ item.caseCode }}</span>
      </span>

      @if (item.unreadCount > 0) {
        <span class="case-unread-badge">{{ item.unreadCount > 99 ? '99+' : item.unreadCount }}</span>
      }
    </button>
  } @empty {
    <div class="case-list-empty">
      <span>No available cases</span>
    </div>
  }
</div>
